/* ============================================================================
   is-reward-bar.js — comportamento della barra premi progressiva.

   Stava dentro lo snippet, che si rende su ogni pagina del sito: ~7 KB di JavaScript
   nell'HTML di ogni pagina, mai messi in cache. Qui si scarica una volta e resta.

   Le note di merito (perche' legge il LORDO, perche' si nasconde a carrello vuoto,
   il morphing di Horizon) sono in testa a snippets/is-reward-bar.liquid.
   ========================================================================= */
(function(){
  if (window.__isRewardBarReady) return;
  window.__isRewardBarReady = true;

  var SOGLIE = [4900, 6900, 8900, 12900, 19900];
  var LABEL  = ['tier_pickup_label','tier_home_label','tier_10_label','tier_15_label','tier_20_label'];
  var MSG    = ['msg_to_pickup','msg_to_home','msg_to_10','msg_to_15','msg_to_20'];
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;

  // il totale PRIMA degli sconti: e' su questo che si ragionano le soglie
  function lordoDi(cart){
    if (!cart || !cart.items) return 0;
    return cart.items.reduce(function(s, i){
      return s + (typeof i.original_line_price === 'number' ? i.original_line_price : (i.line_price || 0));
    }, 0);
  }
  function fmt(cents){
    var v = cents/100;
    return (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2).replace('.', ',')) + ' €';
  }
  function fill(tpl, amount){
    return String(tpl || '').replace(/%importo%/g, '<b>' + fmt(amount) + '</b>');
  }

  class RewardBar extends HTMLElement {
    connectedCallback(){
      this.init();
      RewardBar.instances.push(this);
      this.osserva();
      this.aggiorna();
    }
    disconnectedCallback(){
      if (this.mo) { this.mo.disconnect(); this.mo = null; }
      var i = RewardBar.instances.indexOf(this);
      if (i > -1) RewardBar.instances.splice(i, 1);
    }
    init(){
      var el = this.querySelector('.is-rewardbar__testi');
      if (el) { try { window.__IS_TESTI = JSON.parse(el.textContent); } catch(e){} }
      this.t = (window.__IS_TESTI || {}).reward_bar;
      this.msgEl = this.querySelector('[data-rb-message]');
      this.fillEl = this.querySelector('[data-rb-fill]');
      this.nodesEl = this.querySelector('[data-rb-nodes]');
      this.legendEl = this.querySelector('[data-rb-legend]');
      if (!this.t || !this.msgEl || !this.fillEl) return false;
      this.buildStatic();
      this.render(parseInt(this.dataset.subtotal, 10) || 0);
      return true;
    }
    osserva(){
      var self = this;
      if (this.mo) return;
      this.mo = new MutationObserver(function(){
        var legendaVuota = self.legendEl && self.legendEl.children.length !== SOGLIE.length;
        if (!self.msgEl || !self.contains(self.msgEl) || legendaVuota) {
          if (self.init()) self.aggiorna();
        }
      });
      this.mo.observe(this, { childList: true, subtree: true });
    }
    aggiorna(){
      var self = this, root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { headers:{Accept:'application/json'}, credentials:'same-origin' })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(c){ if (c) self.render(lordoDi(c)); })
        .catch(function(){});
    }
    buildStatic(){
      var n = SOGLIE.length, self = this;
      this.nodesEl.innerHTML = ''; this.legendEl.innerHTML = '';
      SOGLIE.forEach(function(valore, i){
        var dot = document.createElement('span');
        dot.className = 'is-rewardbar__node';
        dot.style.left = ((i + 1) / n) * 100 + '%';
        self.nodesEl.appendChild(dot);
        var li = document.createElement('li');
        li.innerHTML = '<span class="rb-amount">' + fmt(valore) + '</span>' + (self.t[LABEL[i]] || '');
        self.legendEl.appendChild(li);
      });
    }
    render(subtotal){
      if (!this.t || !this.msgEl || !this.contains(this.msgEl)) { if (!this.init()) return; }
      /* Horizon rifa' il DOM del carrello a ogni cambiamento (morphing). Capitava che
         restasse il messaggio ("mancano 30 euro per lo sconto del 10%") ma sparisse
         l'elenco degli scaglioni sotto la barra, perche' nessuno lo ricostruiva: il
         controllo qui sopra guarda solo il messaggio. Se i gradini non ci sono piu',
         si ridisegnano. (28/08/2026) */
      if (this.t && this.legendEl && this.legendEl.children.length !== SOGLIE.length) this.buildStatic();
      // carrello vuoto: la barra non ha niente da promettere
      if (!subtotal || subtotal <= 0) { this.hidden = true; return; }
      var n = SOGLIE.length;
      subtotal = Math.max(0, subtotal || 0);
      var reached = -1;
      for (var i = 0; i < n; i++){ if (subtotal >= SOGLIE[i]) reached = i; }
      var pct;
      if (reached === n - 1) { pct = 100; }
      else {
        var lower = reached < 0 ? 0 : SOGLIE[reached];
        var upper = SOGLIE[reached + 1];
        var span = upper - lower;
        var local = span > 0 ? (subtotal - lower) / span : 0;
        pct = ((reached + 1) + local) / n * 100;
      }
      this.fillEl.style.width = Math.max(0, Math.min(100, pct)).toFixed(2) + '%';
      this.nodesEl.querySelectorAll('.is-rewardbar__node').forEach(function(d, i){
        d.classList.toggle('is-reached', i <= reached);
        d.classList.toggle('is-next', i === reached + 1);
      });
      this.legendEl.querySelectorAll('li').forEach(function(li, i){
        li.classList.toggle('is-reached', i <= reached);
      });
      var html;
      if (reached === n - 1) { html = this.t.msg_complete; }
      else { html = fill(this.t[MSG[reached + 1]], SOGLIE[reached + 1] - subtotal); }
      this.msgEl.innerHTML = html;
      this.hidden = false;
    }
    static refreshAll(subtotal){
      RewardBar.instances.forEach(function(b){ b.render(subtotal); });
    }
  }
  RewardBar.instances = [];
  if (!customElements.get('reward-bar')) customElements.define('reward-bar', RewardBar);

  var pending = null;
  function syncSoon(){
    clearTimeout(pending);
    pending = setTimeout(function(){
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { headers:{Accept:'application/json'}, credentials:'same-origin' })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(cart){ if (cart) RewardBar.refreshAll(lordoDi(cart)); })
        .catch(function(){});
    }, 120);
  }
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function(input){
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = _fetch.apply(this, arguments);
      if (CART_WRITE.test(url)) p.then(function(){ syncSoon(); }).catch(function(){});
      return p;
    };
  }
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url){
    this.__rbCart = CART_WRITE.test(String(url || ''));
    return _open.apply(this, arguments);
  };
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function(){
    if (this.__rbCart) this.addEventListener('load', syncSoon);
    return _send.apply(this, arguments);
  };
  ['cart:updated','cart:refresh','cart:change','cart:build','cart:update','cart-drawer:open'].forEach(function(ev){
    document.addEventListener(ev, syncSoon);
  });
  document.addEventListener('shopify:section:load', syncSoon);
  document.addEventListener('visibilitychange', function(){ if (!document.hidden) syncSoon(); });
  window.addEventListener('pageshow', syncSoon);
})();
